module.exports = __webpack_public_path__ + "static/media/taperedRollerBearing.9d591898.png";